import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";

import { appRoutes } from "routes";
import { useScreen, useTransactionRecords } from "hooks";
import Placeholder from "components/Placeholder";
import AccountLayout from "layouts/AccountLayout";
import TransactionRecordPresenter from "presenters/TransactionRecordPresenter";
import MetaTags from "components/MetaTags";

import { Title } from "../components";

import useStyles from "./useStyles";

const Receipts = () => {
  const classes = useStyles();
  const { isMobile } = useScreen();
  const { loadTransactionRecords, transactionRecords } = useTransactionRecords();

  useEffect(() => {
    loadTransactionRecords();
  }, []);

  return (
    <>
      <style>
        {`@media print {
          body * {
            visibility: hidden;
          }
          #printable, #printable * {
            visibility: visible;
          }
          #printable .print-hide, #printable .print-hide * {
            display: none;
          }
          #printable {
            position: absolute;
            top: 0;
          }
        }`}
      </style>

      <AccountLayout
        title="Funny eCards - Send Custom Greeting Cards Online w/ JibJab! - My Account - Receipts "
        backLink={appRoutes.myAccountPath()}
      >
        <div id="printable">
          <Title title="Receipts" />

          {!isMobile && (
            <TableContainer component={Paper}>
              <Table className={classes.table} size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.head}>Date</TableCell>
                    <TableCell className={classes.head}>Payment Form</TableCell>
                    <TableCell className={classes.head}>Price</TableCell>
                    <TableCell className={`print-hide ${classes.head}`} />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!transactionRecords && (
                    <TableRow className={classes.row}>
                      <TableCell>
                        <Placeholder variant="text" />
                      </TableCell>
                      <TableCell>
                        <Placeholder variant="text" />
                      </TableCell>
                      <TableCell>
                        <Placeholder variant="text" />
                      </TableCell>
                      {!isMobile && (
                        <TableCell>
                          <Placeholder variant="text" />
                        </TableCell>
                      )}
                    </TableRow>
                  )}
                  {transactionRecords &&
                    transactionRecords.map((transRecord) => (
                      <TableRow key={transRecord.id} className={classes.row}>
                        <TableCell>{TransactionRecordPresenter.paidAtDate(transRecord)}</TableCell>
                        <TableCell className={classes.mobileCenter}>
                          {TransactionRecordPresenter.paymentForm(transRecord)}
                        </TableCell>
                        <TableCell>{TransactionRecordPresenter.price(transRecord)}</TableCell>
                        <TableCell className="print-hide">
                          <NavLink exact className={classes.link} to={appRoutes.receiptPath(transRecord.id)}>
                            View
                          </NavLink>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          {isMobile && (
            <TableContainer component={Paper}>
              <Table className={classes.table} size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell className={`${classes.head} ${classes.left}`}>Date</TableCell>
                    <TableCell className={`${classes.head} ${classes.center}`}>Payment Form</TableCell>
                    <TableCell className={`${classes.head} ${classes.right}`}>Price</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!transactionRecords && (
                    <TableRow className={classes.row}>
                      <TableCell>
                        <Placeholder variant="text" />
                      </TableCell>
                      <TableCell>
                        <Placeholder variant="text" />
                      </TableCell>
                      <TableCell>
                        <Placeholder variant="text" />
                      </TableCell>
                    </TableRow>
                  )}
                  {transactionRecords &&
                    transactionRecords.map((transRecord) => (
                      <TableRow key={transRecord.id} className={classes.row}>
                        <TableCell className={classes.left}>
                          {TransactionRecordPresenter.paidAtDate(transRecord)}
                        </TableCell>
                        <TableCell className={classes.center}>
                          {TransactionRecordPresenter.paymentForm(transRecord)}
                          <br />
                          <NavLink exact className={classes.link} to={appRoutes.receiptPath(transRecord.id)}>
                            View
                          </NavLink>
                        </TableCell>
                        <TableCell className={classes.right}>{TransactionRecordPresenter.price(transRecord)}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>

        <Button variant="contained" color="secondary" className={classes.button} onClick={() => window.print()}>
          Print
        </Button>
      </AccountLayout>
      <MetaTags>
        <meta
          name="og:description"
          content="Personalized eCards from JibJab for every occasion. Browse, customize, send funny greeting cards online for birthdays, holidays, valentines, thank yous & more!"
        />
      </MetaTags>
    </>
  );
};

export default Receipts;
